import React from 'react';
import styled from 'styled-components';
import Spacer from '../../../../Common/CanvasForm/Bodies/BodyTypes/Spacer';
import {GetCardTypeForBody} from '../../../../../util/utils';

function PrintViewSpacerBody(props) {
	const { body } = props;

	const formBodyBorder = GetCardTypeForBody(body);

	return (
		<StyledPrintViewSpacerBody className={`StyledPrintViewSpacerBody ${formBodyBorder}`}>
			<section className="SectionBodyData PrintViewSpacerBodyData" id={body.id}>
					<Spacer
						options={body}
					/>
			</section>
		</StyledPrintViewSpacerBody>
	);
}

export default PrintViewSpacerBody;

const StyledPrintViewSpacerBody = styled.section`
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
	}
`;
